module.exports = __webpack_public_path__ + "static/profile-0d3af08d9fe7905ac6b8b679490da6b1.jpg";